




import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Logout",
})
export default class Logout extends Vue {}
